module.exports = __webpack_public_path__ + "1f3ccd00b2aff53d399c522488c8e2fc.png";